import { createAction, isAnyOf } from '@reduxjs/toolkit';
import type { ListenerMiddlewareInstance } from '@reduxjs/toolkit';

import { MODEL_SERVICE_CALL } from 'constants/models';
import dispatchingApi from 'modules/Event/api/dispatching';
import serviceCallApi from 'modules/ServiceCall/api/serviceCall';

export const workOrderNotesSaved = createAction<number | string>(
  'serviceCall/notesSaved',
);

const legacyWorkOrderUpdated = createAction<{ id: number | string }>(
  'SERVICE_CALL_UPDATING_SUCCESS',
);

export function registerWorkOrderNotesSync(
  listener: ListenerMiddlewareInstance,
) {
  return listener.startListening({
    matcher: isAnyOf(
      dispatchingApi.endpoints.update.matchFulfilled,
      dispatchingApi.endpoints.create.matchFulfilled,
      serviceCallApi.endpoints.update.matchFulfilled,
      legacyWorkOrderUpdated.match,
    ),
    effect: (action, { dispatch }) => {
      let modelId;

      if (
        dispatchingApi.endpoints.update.matchFulfilled(action) ||
        dispatchingApi.endpoints.create.matchFulfilled(action)
      ) {
        const values = action.meta.arg.originalArgs;
        if (
          values.model !== MODEL_SERVICE_CALL ||
          (!('notes' in values) && !('sync_work_order_reason' in values))
        ) {
          return;
        }
        modelId = values.model_id;
      } else {
        const workOrder = action.payload as { id?: number | string };
        modelId = workOrder?.id;
        if (modelId) {
          dispatch(
            dispatchingApi.util.invalidateTags([
              'DispatchingList',
              'DispatchingGet',
              'DispatchingUnassignedList',
            ]),
          );
        }
      }

      if (!modelId) return;

      dispatch(serviceCallApi.util.invalidateTags(['ServiceCallGet']));
      dispatch(workOrderNotesSaved(modelId));
    },
  });
}
